/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/destructuring-assignment */
import { IconDeviceFloppy } from '@tabler/icons-react';
import { Button, Group, LoadingOverlay, Paper, Space } from '@mantine/core';
import { useEffect, useState } from 'react';
import { showNotification } from '@mantine/notifications';
import { Table } from 'antd';
import { FilterData, EquipmentFormSearchFilter } from './EquipmentFormSearchFilter';
import { EquipmentType } from '../../../../../../../models/core/equipment.type';
import { SessionStorageKey } from '../../../../../../../utils/constants.utils';
import equipmentsEquipment from '../../../../../../../services/core/equipment.service';
import TableCellEllipsis from '../../../../../../../components/core/TableCellEllipsis/TableCellEllipsis';

type FormViewProps = {
  itemsIdList: number[];
  idEntidade: number | undefined;
  callback(item: EquipmentType | null, action: string, confirmed: boolean): void;
};

export default function EquipmentFormSearch(props: FormViewProps) {
  const [data, setData] = useState<EquipmentType[]>([]);
  const [loading, setLoading] = useState(false);
  const [selectedData, setSelectedData] = useState<EquipmentType[]>([]);

  const handleSubmit = () => {
    props.callback(selectedData?.[0] || null, 'callback', true);
  };

  const clear = () => {
    sessionStorage.removeItem(SessionStorageKey.EquipmentSearch);
    setData([]);
  };

  const filter = async (inputFilterData: FilterData) => {
    try {
      setLoading(true);
      const result = await equipmentsEquipment.search({
        residuoEquipamento: inputFilterData?.residuoEquipamento || null,
        limit: 1000,
        offset: 0,
      });
      sessionStorage.setItem(SessionStorageKey.EquipmentSearch, JSON.stringify(result));
      setData(result);
    } catch (error: any) {
      showNotification({
        title: `Entidade - ${!props.idEntidade ? 'Adicionar' : 'Editar'}`,
        message: error?.isBusinessException ? error.description : 'Não foi possível pesquisar equipamentos.',
        color: 'red',
      });
    } finally {
      setLoading(false);
    }
  };

  const rowSelection = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: EquipmentType[]) => {
      setSelectedData(selectedRows);
    },
    getCheckboxProps: (record: EquipmentType) => ({
      disabled: props.itemsIdList.includes(record.idResiduoEquipamento),
      name: record.idResiduoEquipamento.toString(),
    }),
  };

  useEffect(() => {
    const cacheResult = JSON.parse(
      sessionStorage.getItem(SessionStorageKey.EquipmentSearch) || '[]'
    ) as EquipmentType[];

    if (cacheResult.length > 0) {
      setData(cacheResult);
    } else {
      filter({ residuoEquipamento: '' });
    }
  }, []);

  return (
    <div>
      <EquipmentFormSearchFilter filter={filter} clear={clear} loading={loading} />
      <div style={{ position: 'relative' }}>
        <LoadingOverlay visible={loading} />
        <Paper shadow="xs" p="md" withBorder>
          <Table
            showSorterTooltip={false}
            size="small"
            dataSource={data}
            columns={[
              {
                title: 'Equipamento',
                key: 'residuoEquipamento',
                dataIndex: 'residuoEquipamento',
                sorter: (a: EquipmentType, b: EquipmentType) =>
                  a.residuoEquipamento.localeCompare(b.residuoEquipamento),
              },
              {
                title: 'Descrição',
                key: 'descricao',
                sorter: (a: EquipmentType, b: EquipmentType) => {
                  return (a.descricao || '').localeCompare(b.descricao || '');
                },
                render: (row: EquipmentType) => (
                  <TableCellEllipsis label={row?.descricao} numberOfChars={25} toolTipWidth={300} />
                ),
              },
            ]}
            rowSelection={{ type: 'radio', ...rowSelection }}
            rowKey={(item: EquipmentType) => item.idResiduoEquipamento}
            pagination={{
              pageSizeOptions: [10, 25, 50],
              showSizeChanger: true,
              showTotal: (total, range) => `${range[0]} - ${range[1]} de ${total} resultado(s)`,
            }}
          />
        </Paper>
        <Space h="xl" />
        <Group justify="right">
          <Button leftSection={<IconDeviceFloppy size={18} />} onClick={handleSubmit}>
            Salvar
          </Button>
        </Group>
      </div>
    </div>
  );
}
